import axios from "axios";
import { apiErrorHandler } from "./helper/handler";

const prefix = "marketing-promotion";

const GET_ALL_MARKETING_PROMOTION_URL = `${prefix}/all`;
const CREATE_MARKETING_PROMOTION_URL = `${prefix}/create`;
const UPDATE_MARKETING_PROMOTION_BY_ID_URL = `${prefix}/update-by-id`;
const DELETE_MARKETING_PROMOTION_BY_ID_URL = `${prefix}/delete-by-id`;

/**
 * @func getAllMarketingPromotion
 * @desc get all promotion data
 * @author izeberg
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} promotion array
 */
export const getAllMarketingPromotion = async (queryParams, signal) => {
    try {
        const { data, status } = await axios.get(GET_ALL_MARKETING_PROMOTION_URL, {
            params: queryParams,
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getAllMarketingPromotion");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getAllMarketingPromotion */

/**
 * @func createMarketingPromotion
 * @desc create new promotion
 * @author izeberg
 * @param {Object} body - create promotion body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean} create status
 */
export const createMarketingPromotion = async (body, signal) => {
    try {
        const { status } = await axios.post(CREATE_MARKETING_PROMOTION_URL, body, {
            signal,
        });
        if (status === 201) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "createMarketingPromotion");
        if (err) throw err;
        return undefined;
    }
};
/** End @func createMarketingPromotion */

/**
 * @func updateMarketingPromotionById
 * @desc update promotion by id
 * @author izeberg
 * @param {number} id - promotion id
 * @param {Object} body - update promotion body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean} update status
 */
export const updateMarketingPromotionById = async (id, body, signal) => {
    try {
        const { status } = await axios.put(`${UPDATE_MARKETING_PROMOTION_BY_ID_URL}/${id}`, body, {
            signal,
        });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "updateMarketingPromotionById");
        if (err) throw err;
        return undefined;
    }
};
/** End @func updateMarketingPromotionById */

/**
 * @func deleteMarketingPromotionById
 * @desc delete promotion by id
 * @author izeberg
 * @param {Object} body - create promotion body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} promotion array
 */
export const deleteMarketingPromotionById = async (id, signal) => {
    try {
        const { status } = await axios.delete(`${DELETE_MARKETING_PROMOTION_BY_ID_URL}/${id}`, {
            signal,
        });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "deleteMarketingPromotionById");
        if (err) throw err;
        return undefined;
    }
};
/** End @func deleteMarketingPromotionById */
